import React, { Component } from "react";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import aboutBlue from "../../../assets/about-blue.svg";
import noWinImg from "../../../assets/no-win-image.svg";
import SratchCardModel from "../components/scratch-card-model";
import MultipleVochers from "../components/multipleVouchers";
import Wheel from "../components/wheel";
import rewardsClientX from "../../../utils/api/rewardClientX";
import InlineLoader from "../../../components/InlineLoader";
import { CoverPageSkeleton } from "../../../components/skeleton";
import WonCardTitle from "../components/wonCardTitle";
import { connect } from "react-redux";
import EmptyState from "../../../components/EmptyState";
class Rewards extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rewards: [],
      offers: [],
      isRewardModelOpen: false,
      isModelTransitionDone: false,
      isWheelModelOpen: false,
      currentIndex: 0,
      isRewardFetching: false,
      isFinished: false,
      isFetchingRewards: false,
      isFetchingOffers: false,
      isLastPage: false,
      pageNo: 1,
      activatedCard: null,
    };

    this.loadRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.profile === null) {
      window.location.href = `${process.env.REACT_APP_SSO_URL}/login?continue=${process.env.REACT_APP_URL}`;
    }
    this.initRewards();
    this.setState(
      {
        isFetchingOffers: true,
      },
      () => {
        this.getOffers();
      }
    );

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0 && !this.state.isLastPage) {
          this.setState(
            (prevState) => ({ ...prevState, pageNo: prevState.pageNo + 1 }),
            () => {
              this.state.rewards.length > 0 &&
                this.getUserRewards(this.state.pageNo);
            }
          );
        }
      });
    });
    this.observer.observe(this.loadRef.current);
  }

  initRewards = () => {
    this.setState(
      {
        isFetchingRewards: true,
        activatedCard: null,
        pageNo: 1,
      },
      () => {
        this.getUserRewards(1);
      }
    );
  };

  getOffers = () => {
    rewardsClientX.get("/v1/customer/offers").then((response) => {
      this.setState({
        offers: response.data.data,
        isFetchingOffers: false,
      });
    });
  };

  finished = (item) => {
    this.setState({
      isFinished: true,
    });
    this.activateCard(item);
  };

  getUserRewards = (pageNo) => {
    rewardsClientX
      .get("/v1/customer/cards", {
        params: {
          page: pageNo,
        },
      })
      .then((response) => {
        let isLast;
        isLast = response.data.links.next === null;
        this.setState(
          (prevState) => ({
            ...prevState,
            rewards: prevState.rewards.concat(response.data.data),
            isFetchingRewards: false,
            isLastPage: isLast,
          }),
          () => { }
        );
      });
  };

  openRewardModel = (index) => {
    this.setState({
      isRewardModelOpen: true,
      currentIndex: index,
    });
  };

  closeRewardModelHandler = (isActivated, item) => {
    this.setState(
      {
        isRewardModelOpen: false,
        isModelTransitionDone: false,
      },
      () => {
        isActivated && this.initRewards();
      }
    );
  };

  openWheelModel = (index) => {
    this.setState({
      isWheelModelOpen: true,
      currentIndex: index,
    });
  };

  closeWheelModelHandler = (isActivated, isClaimed) => {
    this.setState(
      {
        isWheelModelOpen: false,
      },
      () => {
        if (isClaimed) {
          this.props.history.push(
            `/rewards/physical-prizes/${this.state.activatedCard[0].id}`
          );
        } else {
          isActivated &&
            this.setState(
              (prevState) => ({
                rewards: [],
              }),
              () => {
                this.initRewards();
              }
            );
        }
      }
    );
  };

  activateCard = (item) => {
    const id = item.id;
    rewardsClientX
      .post(`/v1/customer/cards/${id}/activate`, {})
      .then((response) => {
        this.setState({
          activatedCard: response.data.data,
        });
      });
  };

  getProfile = (card) => {
    const { email_verified, mobile_verified } = this.props.profile;
    if (email_verified && mobile_verified) {
      this.props.history.push(`/rewards/vouchers/${card.id}`);
    } else {
      this.props.history.push(`/verification-info/${card.id}`);
    }
    //   });
  };

  wonCardDetail = (card) => {
    const type = card.type;
    switch (type) {
      case "voucher":
        this.props.history.push(`/verification-info/${card.id}`);
        break;
      case "item":
        this.props.history.push(
          `/rewards/physical-prizes/${card.id}&${card.claim_id ? card.claim_id : ""
          }`
        );
        break;

      default:
        break;
    }
  };

  modelEntered = () => {
    this.setState({ isModelTransitionDone: true });
  };

  render() {
    return (
      <div className="container font-proxima-nova">
        <div className="row mt-3 mb-3 mt-md-4 mb-md-4">
          <div className="col-12">
            <div className="row align-items-center">
              <div className="col-12">
                <small>
                  <Link to="/">
                    <FormattedMessage
                      id="breadcrumbs.home"
                      defaultMessage="Home"
                    />
                  </Link>{" "}
                  /{" "}
                  <strong>
                    <FormattedMessage
                      id="navbar.rewards"
                      defaultMessage="Rewards"
                    />
                  </strong>
                </small>
              </div>
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-12 col-md-8">
            <h2 className="font-proxima-nova-bold d-inline-block">
              <FormattedMessage
                id="rewards.your-rewards"
                defaultMessage="Your Rewards"
              />
            </h2>
            <Link to="/rewards-info">
              <button
                className="btn btn-outline d-inline-block"
                style={{ color: "#087CD8", marginTop: "-0.5rem" }}
              >
                <img src={aboutBlue} alt="" className="mr-1" />{" "}
                <FormattedMessage id="general.info" defaultMessage="Info" />
              </button>
            </Link>
          </div>
          <div className="col-md-4 col-12 text-right">
            <a
              href="#offers"
              className="btn btn-primary home-btn offer-btn w-50"
            >
              <FormattedMessage
                id="rewards.check-offers"
                defaultMessage="
                Check Offers"
              />
            </a>
          </div>
        </div>

        <div className="row mt-3 mb-5 font-proxima-nova">
          {this.state.isFetchingRewards ? (
            <div className="col-12">
              <CoverPageSkeleton rows={2} columns={4} height={65} width={65} />
            </div>
          ) : this.state.rewards.length === 0 ? (
            <div className="empty-state">
              <EmptyState
                title={
                  <FormattedMessage
                    id="rewards.no-rewards"
                    defaultMessage="
           No rewards yet. It's only matter of time!"
                  />
                }
                imageWidth={40}
              />
            </div>
          ) : (
            this.state.rewards.map((item, index) => {
              return (
                <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3" key={index}>
                  <div className="rewards-card">
                    {item.card_type === "unused-card" &&
                      item.type === "scratch-card" && (
                        <React.Fragment>
                          <div
                            className="reward-icon"
                            onClick={() => this.openRewardModel(index)}
                          >
                            <img
                              src={item.image_url}
                              alt="rewards icon."
                              className="d-block"
                            />
                            <h4 className="text-white position-absolute abs-center">
                              <FormattedMessage
                                id="rewards.tap-scratch"
                                defaultMessage="Tap to scratch"
                              />
                            </h4>
                          </div>
                          {this.state.isRewardModelOpen &&
                            this.state.currentIndex === index && (
                              <SratchCardModel
                                reward={item}
                                finished={() => this.finished(item)}
                                activatedCard={this.state.activatedCard}
                                modelEntered={this.modelEntered}
                                closeRewardModelHandler={(isActivated) =>
                                  this.closeRewardModelHandler(
                                    isActivated,
                                    item
                                  )
                                }
                              >
                                {item.rewards.length < 2 ? (
                                  <div>
                                    <div className="reveal-icon">
                                      {this.state.activatedCard &&
                                        this.state.activatedCard.length > 0 && (
                                          <img
                                            src={
                                              this.state.activatedCard[0]
                                                .image_url
                                            }
                                            alt="rewards icon."
                                            className="d-block"
                                          />
                                        )}
                                      {this.state.activatedCard && (
                                        <div className="reward-content">
                                          {this.state.activatedCard.length >
                                            0 ? (
                                            <React.Fragment>
                                              <h5>
                                                {" "}
                                                <FormattedMessage
                                                  id="general.congrats"
                                                  defaultMessage="
                        Congratulations!"
                                                />
                                              </h5>
                                              <p>
                                                <WonCardTitle
                                                  card={
                                                    this.state.activatedCard[0]
                                                  }
                                                />
                                              </p>
                                              <small>
                                                {" "}
                                                <FormattedMessage
                                                  id="rewards.won-on"
                                                  defaultMessage="
                        Won on"
                                                />{" "}
                                                {this.state.activatedCard &&
                                                  this.state.activatedCard
                                                    .length > 0 &&
                                                  this.state.activatedCard[0]
                                                    .winning_date}
                                              </small>
                                            </React.Fragment>
                                          ) : (
                                            <>
                                              <img
                                                src={noWinImg}
                                                alt="rewards icon."
                                                className="d-block"
                                              />
                                              <p style={{ marginTop: "-8rem" }}>
                                                <FormattedMessage
                                                  id="rewards.oops"
                                                  defaultMessage="Oops!"
                                                />
                                              </p>
                                              <h5>
                                                <FormattedMessage
                                                  id="rewards.no-win"
                                                  defaultMessage="Better luck next time"
                                                />
                                              </h5>
                                            </>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  <MultipleVochers />
                                )}
                              </SratchCardModel>
                            )}
                        </React.Fragment>
                      )}
                    {item.card_type === "unused-card" &&
                      item.type === "spin-wheel" && (
                        <React.Fragment>
                          <div
                            className="reward-icon"
                            onClick={() => this.openWheelModel(index)}
                          >
                            <img
                              src={item.image_url}
                              alt="rewards icon."
                              className="d-block"
                            />
                            <h4 className="text-white position-absolute abs-center">
                              <FormattedMessage
                                id="rewards.spin"
                                defaultMessage="Tap To Spin"
                              />
                            </h4>
                          </div>

                          {this.state.isWheelModelOpen &&
                            this.state.currentIndex === index && (
                              <Wheel
                                item={item}
                                finished={() => this.finished(item)}
                                closeWheelModelHandler={(
                                  isActivated,
                                  isClaimed
                                ) =>
                                  this.closeWheelModelHandler(
                                    isActivated,
                                    isClaimed
                                  )
                                }
                                activatedCard={this.state.activatedCard}
                              />
                            )}
                        </React.Fragment>
                      )}
                    {item.card_type === "won-card" && (
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => this.wonCardDetail(item)}
                      >
                        <div className="reveal-icon">
                          <img src={item.image_url} alt="rewards icon." className="d-block" />
                          <h6> {item.display_name}{" "}</h6>
                          <h3 className="text-won">
                            <WonCardTitle card={item} />
                          </h3>
                          <p className="text-secondary reward-date">{item.winning_date}</p>
                          {item.type === "item" &&
                            (item.processed ? (
                              <small className="text-secondary">
                                <FormattedMessage
                                  id="rewards.claimed-prize"
                                  defaultMessage="Prize claimed"
                                />
                              </small>
                            ) : this.state.loading &&
                              index === this.state.currentIndex ? (
                              "loading"
                            ) : (
                              <small
                                className="text-primary"
                                style={{ cursor: "pointer" }}
                                onClick={() => this.claimPrize(index, item.id)}
                              >
                                <FormattedMessage
                                  id="rewards.claim-prize"
                                  defaultMessage=" Claim Prize"
                                />
                              </small>
                            ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })
          )}
          <p style={{ textAlign: "center" }} id="load" ref={this.loadRef}></p>
          {!this.state.isLastPage && (
            <div style={{ textAlign: "center" }}>
              <InlineLoader />
            </div>
          )}
        </div>

        <div className="row mb-3" id="offers">
          <div className="col-12">
            <h2 className="font-proxima-nova-bold d-inline-block">
              <FormattedMessage id="offers.offers" defaultMessage="Offers" />
            </h2>
          </div>
        </div>

        <div className="row mt-3 mb-5 font-proxima-nova">
          {this.state.isFetchingOffers ? (
            <div className="col-12">
              <CoverPageSkeleton rows={1} columns={4} height={40} width={40} />
            </div>
          ) : this.state.offers.length === 0 ? (
            <div className="empty-state">
              <EmptyState
                title={
                  <FormattedMessage
                    id="offers.no-offers"
                    defaultMessage="Currently, we don’t have any active offers, please come back again later"
                  />
                }
                imageWidth={40}
              />
            </div>
          ) : (
            this.state.offers.map((item, index) => {
              return (
                <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3" key={`offer${index}`}>
                  <div className="offer-card d-flex">
                    <div className="card-icon rewards-card">
                      <div className="reward-icon">
                        <img
                          src={item.image_url}
                          alt="rewards icon."
                          className="d-block"
                        />
                      </div>
                    </div>
                    <h4>{item.title}</h4>
                    <p className="text-secondary">{item.description}</p>
                    <small className="text-primary">
                      {" "}
                      <Link to={`/rewards/offers/${item.id}`}>
                        <FormattedMessage
                          id="offers.view-offer-details"
                          defaultMessage="View offer details"
                        />
                      </Link>
                    </small>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    profile: state.global.profile,
  };
}

export default connect(mapStateToProps, null)(Rewards);
